import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue"

import {
  computed,
  watch,
  nextTick,
  defineAsyncComponent,
  type Component,
  ref,
} from 'vue';
import { useRoute } from 'vue-router';
import { Modal as AModal } from 'ant-design-vue';

import BaseIcon from '@/components/BaseIcon.vue';

import { MODALS } from '@/@types/base';
import { detectIos } from '@/helper/utils';
import { useStore } from '@/store';
import { amplitudeInstance } from '@/analytics';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  setup(__props) {

const route = useRoute();
const store = useStore();

const isModalVisible = computed<boolean>(() => {
  return store.state.base.isModalVisible;
});

const modalInnerComponentName = computed<MODALS | null>(() => {
  return store.state.base.modalInnerComponentName;
});

const amplitudeEvents: Record<string, string> = {
  Pricing: 'pricing',
  Home: 'home_page',
  MyPlants: 'my_plants_page',
};

const visible = computed<boolean>({
  get() {
    if (
      modalInnerComponentName.value === MODALS.AUTHORIZATION &&
      isModalVisible.value
    ) {
      const placement = amplitudeEvents[route.name as string];

      if (placement) {
        amplitudeInstance.logEvent('Auth_screen_shown', { placement });
      }
    }

    return isModalVisible.value;
  },
  set() {
    if (modalInnerComponentName.value === MODALS.AUTHORIZATION) {
      amplitudeInstance.logEvent('Auth_screen_skipped');
    }

    return store.dispatch('base/closeModal', null);
  },
});

const innerComponent = computed<Component>(() => {
  const name = modalInnerComponentName.value;

  return name
    ? defineAsyncComponent(
        () => import(/* webpackChunkName: "[request]" */ `./${name}.vue`)
      )
    : null;
});

const closeCb = ref<() => void>();

const cbRegister = (cb: () => void) => {
  closeCb.value = cb;
};

watch(visible, (val) => {
  if (detectIos()) {
    val
      ? document.documentElement.classList.add('ios-hidden')
      : document.documentElement.classList.remove('ios-hidden');
  }

  if (!val) {
    closeCb.value?.();
    closeCb.value = () => ({});

    store.dispatch('base/setIsFromSubscriptionsModal', false);
    return;
  }

  // for QA
  nextTick(() => {
    const closeBtn =
      document.querySelector<HTMLButtonElement>('.ant-modal-close');

    if (closeBtn) {
      closeBtn.dataset.test = 'modal-close-btn';
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AModal), {
    visible: _unref(visible),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    destroyOnClose: true,
    footer: null,
    title: null,
    "wrap-class-name": `base-modal base-modal--${_unref(modalInnerComponentName)}`,
    centered: ""
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(BaseIcon, { name: "close-modal" })
    ]),
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(innerComponent)), {
        "on-close-cb": cbRegister,
        class: "base-modal__container"
      }, null, 32))
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}
}

})